import { render, staticRenderFns } from "./ProgramApplyPage.vue?vue&type=template&id=dceae2ac"
import script from "./ProgramApplyPage.ts?vue&type=script&lang=js&external"
export * from "./ProgramApplyPage.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports